export const mockdata = {
  hero: {
    title: "Hello, my name is",
    name: "Vishal Singh",
    subtitle: "Engineer. Problem Solver.",
    decription1: "Turning complex challenges into elegant solutions",
    decription2:
      "I craft high-performance applications and transform ideas into reality through clean, efficient code.",
    image: "https://avatars.githubusercontent.com/u/12345678?v=4",
    socialLinks: {
      github: "",
    },
  },
  about: {
    title: "About Me",
    avatar: "me.jpg",
    skills: [
      "Coding (not just for fun, but also for work)",
      "Reading (not just memes)",
      "Problem Solving (not just in code)",
      "Chess(not a grandmaster yet)",
      "Mentoring (trying to be a wise sage)",
    ],
    contentHtml: `<p>Hi! I'm Vishal Singh, a software engineer who gets unreasonably excited when code works on the first try (which happens roughly never).</p>
<p>I'm basically a professional puzzle-solver who argues with computers for a living and somehow convinced people this is a real job. I turn "that's impossible" into "oh wait, it actually works" while surviving on coffee and Stack Overflow answers.</p>
<p>I speak fluent front-end, back-end, and "why-is-this-not-working" – think of me as bilingual but nerdier. My code is cleaner than my apartment, and I collect programming languages like some people collect coffee mugs.</p>
<p>Currently turning complex problems into elegant solutions, one caffeine-fueled breakthrough at a time.</p>
Here are a few of the other activities that I love to do!

`,
  },

  Jobs: [
    {
      date: "2023-07-07",
      title: "Software Developer",
      company: "Clayfin Technologies",
      location: "Hybrid",
      range: "Aug 2023 - Present",
      url: "https://www.clayfin.com/",
      description: `<p>As a software developer at Clayfin Technologies, a
fintech company specializing in innovative banking
applications</p>
<p>I leverage React for web development
and React Native for mobile app development,
which are focused on delivering secure and
seamless digital banking experiences</p>`,
    },
  ],
  Featured: [
    {
      date: "1",
      title: "NIA AI",
      cover: "nia.png",
      github: "https://github.com/vishal-git9/Luna_AI",
      external: "https://nia-ai.trudetect.in/",
      tech: [
        "ReactJS",
        "NextJS",
        "Shadcn",
        "TailwindCSS",
        "WebRTC",
        "Go",
        "mongodb",
        "OpenAI",
      ],
      showInProjects: true,
      html: `<p>Nia is your voice-powered AI girlfriend—flirty, caring, and always listening. Built to feel real,</p>`
    },
    {
      date: "2",
      title: "Blissy App",
      cover: "blissy.png",
      github: "https://github.com/vishal-git9/Blissy_App",
      external: "https://play.google.com/store/apps/details?id=com.blissy",
      tech: [
        "React Native",
        "TypeScript",
        "TailwindCSS",
        "Firebase",
        "Redux Toolkit",
        "NodeJS",
        "Express",
        "Websockets",
        "MongoDB",
      ],
      showInProjects: true,
      html: `<p>Your Ultimate Anonymous Chat App for Emotional Support,</p>
      <p>Experience Genuine Connections with Blissy built on top of React Native.</p>`,
    },
    {
      date: "3",
      title: "TruDetect",
      cover: "trudetect.png",
      github: "https://github.com/info-trudetect/client_landing",
      external: "",
      tech: [
        "React",
        "NextJS",
        "Framer Motion",
        "TypeScript",
        "Redux Toolkit",
        "TailwindCSS",
        "shadcn",
        "OpenAI",
        "GO",
        "Websockets",
        "MongoDB",
      ],
      showInProjects: true,
      html: `<p>Trudetect is an AI onboarding platform built to tackle user onboarding challenges in business, it is still in Development.</p>`
    },
  ],
  Projects: [
    {
      date: "2025-02-12",
      title: "Resume Analyzer",
      github: "https://github.com/vishal-git9/Resume_Analyzer",
      external: "https://resume-checker-lake.vercel.app/",
      tech: ["React","Typescript", "Tailwind CSS", "shadcn", "OpenAI"],
      company: "",
      showInProjects: true,
      html: `
<p>The application scans resumes, extracts key information including skills, experience, and qualifications, and generates a comprehensive score based on job requirements.</p>
<p>Features include keyword extraction, tech stack analysis, experience evaluation, and personalized improvement suggestions.</p>`,
    },
    {
      date: "2023-12-12",
      title: "WorkforceIQ",
      github: "https://github.com/vishal-git9/WorkforceIQ",
      external: "",
      tech: ["React", "CSS", "JavaScript", "Node.js", "Express", "MongoDB"],
      company: "Clayfin Technologies",
      showInProjects: true,
      html: `<p>An internal employee assessment and performance tracking platform built for Clayfin Technologies.</p>
  <p>Helps managers evaluate employee performance, track skill development, and manage team efficiency using a comprehensive dashboard system.</p>`,
    },
     {
      date: "2023-10-12",
      title: "Interview Managment App",
      github: "https://github.com/vishal-git9/Interview_management_App",
      external: "",
      tech: ["React Native", "CSS", "JavaScript","Java","Firebase", "Native Modules", "Json Server"],
      company: "Clayfin Technologies",
      showInProjects: true,
    html: `<p>Clayfin Interview Management Portal is a comprehensive solution designed to streamline the hiring process.</p>
<p>With features like automated notifications, resume checker, and interview feedback collection, the portal ensures a seamless recruitment experience for both recruiters and candidates.</p>`,
    },
    {
      date: "2023-2-12",
      title: "Typefast",
      github: "https://github.com/vishal-git9/chaabi_assignment",
      external: "https://typefast.netlify.app/",
      tech: ["React", "CSS", "JavaScript"],
      company: "Masai School",
      showInProjects: true,
  html: `<p>An interactive typing speed application designed to help users improve their typing skills through practice.</p>
  <p>Features include real-time WPM tracking, accuracy measurement, and progress monitoring to help users enhance their typing proficiency.</p>`
    },
     {
      date: "2023-2-12",
      title: "ClickyBall Game",
      github: "https://github.com/hrusikesh8280/Clicky-Ball-Games",
      external: "https://clickyball.vercel.app/",
      tech: ["React", "CSS", "JavaScript"],
      company: "Masai School",
      showInProjects: true,
      html: `<p>Cliky Ball is a fun and addictive web-based game where you match colors as quickly as possible before time runs out. Built using MongoDB, Express.js, Node.js, React, TypeScript, and Tailwind CSS.</p>
  <p>the game is fast and responsive. Play in short bursts and challenge your color-matching skills. Try Cliky Ball now!.</p>`,
    },
    {
      date: "2023-3-23",
      title: "Lenskart Clone",
      github: "https://github.com/vishal-git9/Lenskart_clone",
      external: "https://eyekart.netlify.app/",
      tech: ["React", "CSS", "JavaScript","MockDB","Json Server"],
      company: "Masai School",
      showInProjects: true,
      html: `<p>Lenskart is an Indian multinational optical prescription eyewear retail chain, based in Faridabad. As of May 2022, Lenskart has 1,000 stores across 223 cities in India.</p>
  <p>Its manufacturing facility in New Delhi manufactures 3 lakh glasses a month.</p>`,
    },
    {
      date: "2023-2-12",
      title: "Blog App",
      github: "https://github.com/vishal-git9/notes_App",
      external: "https://blogapp-blush.vercel.app/",
      tech: ["React", "CSS","chakraUI", "JavaScript", "Node.js", "Express", "MongoDB"],
      company: "Masai School",
      showInProjects: true,
      html: `<p>this is blog App built using react and chakraUI, this blog app allows user to create blogs edit blogs set deadlines also delete blogs.</p>
  <p>it also has an authentication functionality that lets users to secure their blogs data.</p>`,
    },
    {
      date: "2023-2-12",
      title: "Mailchimp Clone",
      github: "https://github.com/vishal-git9/Mailchimp_clone",
      external: "https://lightmail.netlify.app/",
      tech: ["React", "CSS", "JavaScript"],
      company: "Masai School",
      showInProjects: true,
      html: `<p>Mailchimp is a web-based email marketing service that allows businesses and organizations to send newsletters, promotional emails, and other types of marketing emails to their subscribers.</p>
  <p> It is a popular tool among small businesses and organizations because it is easy to use, has a variety of features, and offers a free plan for small lists.</p>`,
    },
    {
      date: "2025-5-12",
      title: "Prescription Reader",
      github: "https://github.com/vishal-git9/Prescription_Analyzer",
      external: "",
      tech: ["React", "CSS", "Typescript", "Tailwind CSS", "shadcn", "OpenAI"],
      company: "",
      showInProjects: true,
      html: `<p>Upload doctor prescritpion and it will give you the exact disease info, medication and other info there in prescription.</p>`,
    },
    
    {
      date: "2023-2-12",
      title: "Tax Calculator",
      github: "https://github.com/vishal-git9/itax_easy_assignment",
      external: "https://taxeasy-tawny.vercel.app",
      tech: ["React", "CSS", "JavaScript"],
      company: "Masai School",
      showInProjects: true,
      html: `<p>A comprehensive financial calculator application featuring HRA (House Rent Allowance) and Advance Tax calculation tools.</p>
  <p>Users can calculate their HRA exemptions and estimate advance tax liability with an intuitive interface and accurate calculations based on current tax regulations.</p>`,
    },
  ],
  contact: {
  title: 'Get In Touch',
  buttonText: 'Mail Me',
  contentHtml: `<p>Ready to join forces with creative minds who believe "impossible" is just another word for "interesting challenge".</p>`
  },
};
